import { useState, useEffect, useContext } from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import CircularProgress from "@mui/material/CircularProgress";
// import Typography from "@mui/material/Typography";

import TopAppBar from "../../baseLayout/TopAppBar";
import { useAuthenticated, Loading, Error } from "react-admin";
import { NoEvents, EventsList } from "../../components";
import { useBottomScrollListener } from "react-bottom-scroll-listener";
import IEvent from "../../dataProvider/interfaces/IEvent";
import { useRedirect } from "react-admin";
import { routePaths } from "../../baseLayout/SidebarMenu";
import { APIContext } from "../../store/APIStore";
import { StoreContext } from "./../../store/Store";
import FdTypography from "../../components/UIComponents/Typography/FdTypography";

const classes = {
    wrapper: {
      paddingLeft: "10%",
      paddingRight: "10%",
      paddingTop: "60px",
      backgroundColor: "#f9f9f9",
      minHeight: "100vh",
    },
  };

const ArchivedEvents = () => {
  useAuthenticated();
  const redirect = useRedirect();
  const [events, setEvents] = useState<IEvent[]>([]);
  const [loading, setLoading] = useState(true); // page loading
  const [dataLoading, setDataLoading] = useState(false); // data loading
  const [eventsCount, setEventsCount] = useState(0);
  const [error, setError] = useState<string>();
  const api = useContext(APIContext);
  const [state, dispatch] = useContext(StoreContext);

  // load the events
  useEffect(() => {
    loadEvents();
    if (state.selectedEvent) {
      dispatch({ type: "SET_SELECTED_EVENT", payload: null });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // load new events when scrolling at the bottom of the list
  useBottomScrollListener(() => {
    if (events.length < eventsCount) {
      loadEvents(events.length, events);
    }
  });

  const loadEvents = (start?: number, loadedEvents: any[] = []) => {
    setDataLoading(true);
    api.eventService
      .getEvents({
        archived: true,
        start,
      })
      .then(({ data, count }: { data: any; count: number }) => {
        // setEventsList(data.data.flatMap((i: any) => [i, i, i]));
        const newEvents = [...loadedEvents, ...data];
        setLoading(false);
        setDataLoading(false);
        setEvents(newEvents);
        setEventsCount(count);
      })
      .catch((error: any) => {
        setError(error.response.data.message);
        setLoading(false);
        setDataLoading(false);
      });
  };

  if (error) {
    //@ts-ignore
    return <Error error={{ name: "error", message: error }} />;
  }

  return (
    <>
        <TopAppBar />
        <Box sx={classes.wrapper}>
          {events.length > 0 && (
            <Box pt={10} textAlign="center">
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="baseline"
              >
                <FdTypography label="Archived Events" variant="h1" component="h1" />
                <Box ml={2} flexGrow={1} textAlign="left">
                  <Button
                    onClick={() => {
                      redirect(`/${routePaths.ACTIVE_EVENTS}`);
                    }}
                  >
                    See active events
                  </Button>
                </Box>
              </Box>
              <Divider />
              {!loading && (
                <>
                  <EventsList
                    events={events}
                    selectEvent={(event: IEvent) => {
                      redirect(
                        `/${routePaths.EVENTS}/${event.id}/${routePaths.EDIT}`
                      );
                    }}
                  />
                  {dataLoading && (
                    <CircularProgress
                      style={{ marginTop: "20px", marginBottom: "20px" }}
                    />
                  )}
                </>
              )}
              {loading && <Loading />}
            </Box>
          )}
          {!loading && events.length === 0 && <NoEvents />}
          {loading && events.length === 0 && <Loading />}
        </Box>
     </>
  );
};

export default ArchivedEvents;
